export type IconName =
  | 'dashboard'
  | 'modules'
  | 'shield'
  | 'privacy'
  | 'book'
  | 'sun'
  | 'moon'
  | 'auto'
  | 'logout'
  | 'login'
  | 'chevron-down'
  | 'menu'
  | 'panel-left-close'
  | 'panel-left-open'
  | 'arrow-right'
  | 'check'
  | 'send'
  | 'play'
  | 'close'
  | 'user'
  | 'key'
  | 'fingerprint'
  | 'edit'
  | 'plus'
  | 'star'
  | 'upload'
  | 'map-pin'
  | 'eye'
  | 'trash'
  | 'download'
  | 'print'
  | 'money'
  | 'folder'
  | 'folder-open'
  | 'refresh'
  | 'search'
  | 'settings'
  | 'bell'
  | 'calendar'
  | 'clipboard-check'
  | 'file-text'
  | 'hard-hat'
  | 'alert-triangle'
  | 'help-circle'
  | 'filter'
  | 'mail'
  | 'google'
  | 'density-compact'
  | 'density-normal'
  | 'density-comfortable'

export function icon(name: IconName, className = 'h-4 w-4'): string {
  const common = `class="${className}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"`

  switch (name) {
    case 'dashboard':
      return `<svg ${common}><path d="M4 13.5V6.5A2.5 2.5 0 0 1 6.5 4h3A2.5 2.5 0 0 1 12 6.5v7A2.5 2.5 0 0 1 9.5 16h-3A2.5 2.5 0 0 1 4 13.5Z"/><path d="M12 17.5v-11A2.5 2.5 0 0 1 14.5 4h3A2.5 2.5 0 0 1 20 6.5v11A2.5 2.5 0 0 1 17.5 20h-3A2.5 2.5 0 0 1 12 17.5Z"/></svg>`
    case 'modules':
      return `<svg ${common}><path d="M4 7.5A2.5 2.5 0 0 1 6.5 5h11A2.5 2.5 0 0 1 20 7.5v9A2.5 2.5 0 0 1 17.5 19h-11A2.5 2.5 0 0 1 4 16.5Z"/><path d="M9 5v14"/><path d="M4 10h16"/></svg>`
    case 'shield':
      return `<svg ${common}><path d="M12 3l8 4v6c0 5-3.4 9.2-8 10-4.6-.8-8-5-8-10V7l8-4Z"/><path d="M9.5 12.2l1.9 1.9 3.8-4.2"/></svg>`
    case 'privacy':
      return `<svg ${common}><path d="M7 11V8.6A5 5 0 0 1 12 4a5 5 0 0 1 5 4.6V11"/><path d="M7 11h10a2.5 2.5 0 0 1 2.5 2.5v5A2.5 2.5 0 0 1 17 21H7a2.5 2.5 0 0 1-2.5-2.5v-5A2.5 2.5 0 0 1 7 11Z"/><path d="M12 15.2v2.6"/></svg>`
    case 'book':
      return `<svg ${common}><path d="M7.5 4.5h11v15.8a1.2 1.2 0 0 1-1.2 1.2H7.5a3 3 0 0 0 0-6h11"/><path d="M7.5 4.5A3 3 0 0 0 4.5 7.5v12.8A3 3 0 0 1 7.5 17.3"/></svg>`
    case 'sun':
      return `<svg ${common}><path d="M12 17.2a5.2 5.2 0 1 0 0-10.4 5.2 5.2 0 0 0 0 10.4Z"/><path d="M12 2.8v2.1"/><path d="M12 19.1v2.1"/><path d="M4.9 4.9l1.5 1.5"/><path d="M17.6 17.6l1.5 1.5"/><path d="M2.8 12h2.1"/><path d="M19.1 12h2.1"/><path d="M4.9 19.1l1.5-1.5"/><path d="M17.6 6.4l1.5-1.5"/></svg>`
    case 'moon':
      return `<svg ${common}><path d="M21 14.3A7.9 7.9 0 0 1 9.7 3a7.3 7.3 0 1 0 11.3 11.3Z"/></svg>`
    case 'auto':
      return `<svg ${common}><path d="M12 4.2v5.2"/><path d="M12 14.6v5.2"/><path d="M4.2 12h5.2"/><path d="M14.6 12h5.2"/><path d="M6.1 6.1l3.7 3.7"/><path d="M14.2 14.2l3.7 3.7"/><path d="M17.9 6.1l-3.7 3.7"/><path d="M9.8 14.2l-3.7 3.7"/></svg>`
    case 'logout':
      return `<svg ${common}><path d="M10 7V6.5A2.5 2.5 0 0 1 12.5 4h5A2.5 2.5 0 0 1 20 6.5v11A2.5 2.5 0 0 1 17.5 20h-5A2.5 2.5 0 0 1 10 17.5V17"/><path d="M13 12H4"/><path d="M6.5 9.5 4 12l2.5 2.5"/></svg>`
    case 'login':
      return `<svg ${common}><path d="M14 7V6.5A2.5 2.5 0 0 0 11.5 4h-5A2.5 2.5 0 0 0 4 6.5v11A2.5 2.5 0 0 0 6.5 20h5A2.5 2.5 0 0 0 14 17.5V17"/><path d="M11 12h9"/><path d="M17.5 9.5 20 12l-2.5 2.5"/></svg>`
    case 'chevron-down':
      return `<svg ${common}><path d="m6 9 6 6 6-6"/></svg>`
    case 'menu':
      return `<svg ${common}><path d="M4 7h16"/><path d="M4 12h16"/><path d="M4 17h16"/></svg>`
    case 'panel-left-close':
      return `<svg ${common}><path d="M4 5.5A2.5 2.5 0 0 1 6.5 3h11A2.5 2.5 0 0 1 20 5.5v13A2.5 2.5 0 0 1 17.5 21h-11A2.5 2.5 0 0 1 4 18.5Z"/><path d="M9 3v18"/><path d="m15 9-3 3 3 3"/></svg>`
    case 'panel-left-open':
      return `<svg ${common}><path d="M4 5.5A2.5 2.5 0 0 1 6.5 3h11A2.5 2.5 0 0 1 20 5.5v13A2.5 2.5 0 0 1 17.5 21h-11A2.5 2.5 0 0 1 4 18.5Z"/><path d="M9 3v18"/><path d="m12 9 3 3-3 3"/></svg>`
    case 'arrow-right':
      return `<svg ${common}><path d="M4 12h16"/><path d="m14 6 6 6-6 6"/></svg>`
    case 'check':
      return `<svg ${common}><path d="m5 12.5 4.2 4.2L19 7"/></svg>`
    case 'send':
      return `<svg ${common}><path d="m3 11.6 18-8.6-6.8 18-2.8-7.2-8.4-2.2Z"/><path d="M11.4 13.8 21 3"/></svg>`
    case 'play':
      return `<svg ${common}><path d="M8 6.5v11l9-5.5-9-5.5Z"/></svg>`
    case 'close':
      return `<svg ${common}><path d="m6 6 12 12"/><path d="m18 6-12 12"/></svg>`
    case 'user':
      return `<svg ${common}><path d="M12 13a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"/><path d="M20 21c0-3.3-3.6-6-8-6s-8 2.7-8 6"/></svg>`
    case 'key':
      return `<svg ${common}><path d="M15.5 7.5a5 5 0 1 0-5.7 5.7L5 18v2h2v-2h2v-2h2l1.3-1.3a5 5 0 0 0 3.2-7.2Z"/><circle cx="16" cy="8" r="1"/></svg>`
    case 'fingerprint':
      return `<svg ${common}><path d="M2 12a10 10 0 0 1 18-6"/><path d="M2 16h.01"/><path d="M21.8 16c.2-2 .13-5.35 0-6"/><path d="M5 19.5C5.5 18 6 15 6 12a6 6 0 0 1 .34-2"/><path d="M8.65 22c.21-.66.45-1.32.57-2"/><path d="M9 6.8a6 6 0 0 1 9 5.2v2"/><path d="M12 10a2 2 0 0 0-2 2c0 1.02-.1 2.51-.26 4"/><path d="M14 13.12c0 2.38 0 6.38-1 8.88"/><path d="M17.29 21.02c.12-.6.43-2.3.5-3.02"/></svg>`
    case 'edit':
      return `<svg ${common}><path d="M15.2 4.8a2.1 2.1 0 0 1 3 3L7.5 18.5 3 20l1.5-4.5Z"/></svg>`
    case 'plus':
      return `<svg ${common}><path d="M12 5v14"/><path d="M5 12h14"/></svg>`
    case 'star':
      return `<svg ${common}><path d="m12 3.8 2.5 5.1 5.6.8-4 4 1 5.6-5.1-2.7-5.1 2.7 1-5.6-4-4 5.6-.8L12 3.8Z"/></svg>`
    case 'upload':
      return `<svg ${common}><path d="M12 16V5"/><path d="m7.5 9.5 4.5-4.5 4.5 4.5"/><path d="M5 18.5h14"/></svg>`
    case 'map-pin':
      return `<svg ${common}><path d="M12 21s6-5.2 6-10a6 6 0 1 0-12 0c0 4.8 6 10 6 10Z"/><circle cx="12" cy="11" r="2.2"/></svg>`
    case 'eye':
      return `<svg ${common}><path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z"/><circle cx="12" cy="12" r="3"/></svg>`
    case 'trash':
      return `<svg ${common}><path d="M4 7h16"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M6 7l1 14h10l1-14"/><path d="M9 7V4h6v3"/></svg>`
    case 'download':
      return `<svg ${common}><path d="M12 5v11"/><path d="m7.5 11.5 4.5 4.5 4.5-4.5"/><path d="M5 18.5h14"/></svg>`
    case 'print':
      return `<svg ${common}><path d="M7 9V4h10v5"/><path d="M7 17H5.5A2.5 2.5 0 0 1 3 14.5v-2A2.5 2.5 0 0 1 5.5 10h13A2.5 2.5 0 0 1 21 12.5v2a2.5 2.5 0 0 1-2.5 2.5H17"/><path d="M7 14h10v6H7z"/><path d="M17 12h.01"/></svg>`
    case 'money':
      return `<svg ${common}><path d="M4 7.5A2.5 2.5 0 0 1 6.5 5h11A2.5 2.5 0 0 1 20 7.5v9A2.5 2.5 0 0 1 17.5 19h-11A2.5 2.5 0 0 1 4 16.5Z"/><path d="M12 15.5c1.7 0 3-1.1 3-2.5s-1.3-2.5-3-2.5-3 1.1-3 2.5 1.3 2.5 3 2.5Z"/><path d="M7 9h.01"/><path d="M17 15h.01"/></svg>`
    case 'folder':
      return `<svg ${common}><path d="M3 7.5A2.5 2.5 0 0 1 5.5 5h3.4a2 2 0 0 1 1.4.6L11.7 7h6.8A2.5 2.5 0 0 1 21 9.5v7A2.5 2.5 0 0 1 18.5 19h-13A2.5 2.5 0 0 1 3 16.5Z"/></svg>`
    case 'folder-open':
      return `<svg ${common}><path d="M3 7.5A2.5 2.5 0 0 1 5.5 5h3.4a2 2 0 0 1 1.4.6L11.7 7h6.8A2.5 2.5 0 0 1 21 9.5V11H3Z"/><path d="M3 11h18l-2 6.5A2 2 0 0 1 17 19H5.5A2.5 2.5 0 0 1 3 16.5Z"/></svg>`
    case 'refresh':
      return `<svg ${common}><path d="M20 6v5h-5"/><path d="M4 18v-5h5"/><path d="M18.2 9A7 7 0 0 0 6.1 6.7L4 9"/><path d="M5.8 15a7 7 0 0 0 12.1 2.3L20 15"/></svg>`
    case 'search':
      return `<svg ${common}><circle cx="11" cy="11" r="6.5"/><path d="m20 20-4.2-4.2"/></svg>`
    case 'settings':
      return `<svg ${common}><path d="M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z"/><path d="M19.4 15a7.9 7.9 0 0 0 .1-1 7.9 7.9 0 0 0-.1-1l2-1.5-2-3.5-2.4 1a7.8 7.8 0 0 0-1.7-1l-.4-2.6H9.1l-.4 2.6a7.8 7.8 0 0 0-1.7 1l-2.4-1-2 3.5 2 1.5a7.9 7.9 0 0 0-.1 1 7.9 7.9 0 0 0 .1 1l-2 1.5 2 3.5 2.4-1a7.8 7.8 0 0 0 1.7 1l.4 2.6h5.8l.4-2.6a7.8 7.8 0 0 0 1.7-1l2.4 1 2-3.5Z"/></svg>`
    case 'bell':
      return `<svg ${common}><path d="M18 16H6l1.2-1.2A4 4 0 0 0 8 12.5V10a4 4 0 0 1 8 0v2.5a4 4 0 0 0 .8 2.3L18 16Z"/><path d="M10 19a2 2 0 0 0 4 0"/></svg>`
    case 'calendar':
      return `<svg ${common}><path d="M7 4v2"/><path d="M17 4v2"/><path d="M5 8h14"/><path d="M6.5 5.5A2.5 2.5 0 0 1 9 3h6a2.5 2.5 0 0 1 2.5 2.5V19.5A2.5 2.5 0 0 1 15 22H9a2.5 2.5 0 0 1-2.5-2.5Z"/></svg>`
    case 'clipboard-check':
      return `<svg ${common}><path d="M9 5.5A2.5 2.5 0 0 1 11.5 3h1A2.5 2.5 0 0 1 15 5.5V6h3.5A2.5 2.5 0 0 1 21 8.5v10A2.5 2.5 0 0 1 18.5 21h-13A2.5 2.5 0 0 1 3 18.5v-10A2.5 2.5 0 0 1 5.5 6H9Z"/><path d="m9 13.5 2 2 4-4.5"/></svg>`
    case 'file-text':
      return `<svg ${common}><path d="M8 4.5h7.5L18 7v12.5A2.5 2.5 0 0 1 15.5 22h-9A2.5 2.5 0 0 1 4 19.5v-13A2.5 2.5 0 0 1 6.5 4H8Z"/><path d="M14 4.5V8h3.5"/><path d="M8 12h8"/><path d="M8 16h8"/></svg>`
    case 'hard-hat':
      return `<svg ${common}><path d="M4 14.5V12a8 8 0 0 1 16 0v2.5"/><path d="M3.5 14.5h17"/><path d="M10 18.5h4"/><path d="M12 10.5V7"/></svg>`
    case 'alert-triangle':
      return `<svg ${common}><path d="M12 4.5 3.5 19h17Z"/><path d="M12 10v4"/><path d="M12 17h.01"/></svg>`
    case 'help-circle':
      return `<svg ${common}><circle cx="12" cy="12" r="8.5"/><path d="M9.5 9.2a2.8 2.8 0 0 1 5 1.4c0 2-2.5 2.2-2.5 3.9"/><path d="M12 17.5h.01"/></svg>`
    case 'filter':
      return `<svg ${common}><path d="M4 6h16"/><path d="M7 12h10"/><path d="M10 18h4"/></svg>`
    case 'mail':
      return `<svg ${common}><path d="M4 6.5A2.5 2.5 0 0 1 6.5 4h11A2.5 2.5 0 0 1 20 6.5v11A2.5 2.5 0 0 1 17.5 20h-11A2.5 2.5 0 0 1 4 17.5Z"/><path d="m4 7 8 6 8-6"/></svg>`
    case 'google':
      return `<svg class="${className}" viewBox="0 0 24 24" aria-hidden="true"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>`
    case 'density-compact':
      return `<svg ${common}><path d="M4 7h16"/><path d="M4 12h16"/><path d="M4 17h16"/></svg>`
    case 'density-normal':
      return `<svg ${common}><path d="M4 6.5h7"/><path d="M13 6.5h7"/><path d="M4 12h7"/><path d="M13 12h7"/><path d="M4 17.5h7"/><path d="M13 17.5h7"/></svg>`
    case 'density-comfortable':
      return `<svg ${common}><path d="M4 8h16"/><path d="M4 16h16"/></svg>`
    default:
      return `<svg ${common}><path d="M12 5v14"/><path d="M5 12h14"/></svg>`
  }
}